import { useTranslation } from "react-i18next";

import { body1SemiBoldStyles } from "shared";

const NoNews = () => {
    const { t } = useTranslation();

    return (
        <div
            css={[
                body1SemiBoldStyles,
                {
                    textAlign: "center",
                    marginTop: "48px",

                    "@media (max-width: 1099px)": {
                        margin: "48px 0"
                    }
                }
            ]}
        >
            {t("Dashboard##empty state##title##news")}
        </div>
    );
};

export default NoNews;
